import AllClients from './AllClients';
import ClientUserDetails from './ClientUserDetails';

import './styles.scss';

const exports = { AllClients, ClientUserDetails };

export default exports;
